import React from 'react'
import {connect} from 'react-redux'

class GroupChatAvatarBookmarkedIndicator extends React.Component {
  render () {
    if (!this.props.bookmarkedGroup) return false

    return (
      <div className='bookmarked-indicator'>
        <i className='rc-icon-bookmark'/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    bookmarkedGroup: state.getIn(['groups', '_bookmarks', 'all', ownProps.groupId])
  }
}

const GroupChatAvatarBookmarkedIndicatorContainer = connect(
  mapStateToProps
)(GroupChatAvatarBookmarkedIndicator)

export default GroupChatAvatarBookmarkedIndicatorContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chat_avatar_bookmarked_indicator.js
 **/